<template>
  <div :class="props.classes">
    <a
      :href="props.appleLink"
      class="btn -apple"
      :disabled="processing ? !!processing : undefined"
      @click="disableButton('apple', $event)"
    >
      <img :src="`${userAuthStore.cdn.prefix}/assets/img/icon/apple-small-white.svg`" alt="Apple" />
      <div>
        {{ processing === 'apple' ? 'Processing...' : 'Sign in with Apple' }}
      </div>
    </a>
    <a
      :href="props.facebookLink"
      class="btn -fbook"
      :disabled="processing ? !!processing : undefined"
      @click="disableButton('facebook', $event)"
    >
      <span class="iconfont-facebook"></span>
      {{ processing === 'facebook' ? 'Processing...' : 'Sign in with Facebook' }}
    </a>
    <a
      :href="props.googleLink"
      class="btn -google"
      :disabled="processing ? !!processing : undefined"
      @click="disableButton('google', $event)"
    >
      <span class="iconfont-google"></span>
      {{ processing === 'google' ? 'Processing...' : 'Sign in with Google' }}
    </a>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useUserAuthStore } from '@/stores/user-auth'

/** PROPS **/
const props = withDefaults(
  defineProps<{
    classes?: string
    appleLink?: string
    facebookLink?: string
    googleLink?: string
  }>(),
  {
    classes: 'btn-pair',
    appleLink: '/login/apple',
    facebookLink: '/login/facebook',
    googleLink: '/login/google',
  },
)

/** STATE **/
const processing = ref('')
const userAuthStore = useUserAuthStore()

/** METHODS **/
const disableButton = (socialButton: string, event: MouseEvent) => {
  if (processing.value) {
    event.preventDefault()
    return
  }

  processing.value = socialButton
}
</script>
